import * as api from '../../../requests'
import { SET_UNRECONCILE_USERS, SET_BATCHES } from './UnreconcileReducer'
import { setErrorToast } from '../../../actions'

export const getReconcileUsers = () => {
  return (dispatch) => {
    api.GET_UNRECONCILE_USERS(
      (users) => dispatch({ type: SET_UNRECONCILE_USERS, users }),
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
      }
    )
  }
}

export const getReconciledBatches = (appUserID, callback) => {
  return (dispatch) => {
    api.GET_RECONCILED_BATCHES(
      appUserID,
      (batches) => {
        dispatch({ type: SET_BATCHES, batches })
        callback()
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
        callback()
      }
    )
  }
}

export const unReconcilePaymentBatches = (appUserID, batches, callback) => {
  return (dispatch) => {
    api.UNRECONCILE_BATCH(
      batches,
      appUserID,
      () => {
        dispatch(getReconciledBatches(appUserID, callback))
        // dispatch(getReconciledBatches(appUserID, null));
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast())
        callback()
      }
    )
  }
}
